import './JournalListGroup.scss'

import { useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Col, ListGroup, Row } from 'react-bootstrap'
import cn from 'classnames'

import { navigateTo } from 'components/common/navigation'
import { ROUTE_ACTIVITIES_JOURNALING_DAILY_ALL } from 'components/common/helpers/Paths'

export default function JournalListGroup(props) {
  const history = useHistory()
  const { journalData, activeJournalIndex } = props
  const [sortedJournalData, setSortedJournalData] = useState([])

  const onJournalClick = (entryId, journalId) => {
    navigateTo(
      `${ROUTE_ACTIVITIES_JOURNALING_DAILY_ALL}/${journalId}/${entryId}`,
      history
    )
  }

  useMemo(() => {
    const sortedJournalData = journalData.sort(
      (a, b) => new Date(b.created_on) - new Date(a.created_on)
    )
    setSortedJournalData(sortedJournalData)
  }, [journalData])

  return (
    <div className='journal-child-container'>
      <ListGroup variant='flush'>
        {sortedJournalData.length ? (
          sortedJournalData.map((journal, index) => (
            <ListGroup.Item
              key={journal.id}
              className={cn('py-3 px-2', {
                'journal-child-active-journal':
                  journal.id === activeJournalIndex
              })}
            >
              <Row
                className='journal-child-cell align-items-center cursor-pointer'
                onClick={() => onJournalClick(journal.id, journal.journal_id)}
              >
                <Col xs={2} className='emoji'>
                  {journal.journal_emoji || ''}
                </Col>
                <Col xs={3} className='px-0'>
                  <span>
                    {new Date(journal.created_on).toLocaleDateString()}
                  </span>
                </Col>
                <Col xs={7}>
                  <h5 className='mb-0'> {journal.journal_text} </h5>
                </Col>
              </Row>
            </ListGroup.Item>
          ))
        ) : (
          <div className='no-cards'>
            <p>Nothing here yet</p>
          </div>
        )}
      </ListGroup>
    </div>
  )
}
